
import base from "./base.service";

const instance = base.service(); 

export const getAll = () => {
    return instance.get("/dokument/all"); 
};

export const deleteDokument = (id) =>
{
    return instance.delete(`/dokument/brisanje/${id}`);
}

export const addDokument = (newDocument) =>
{
    return instance.post(`/dokument`,newDocument);
}

const getByNaziv = (naziv) => {
  return instance.get(`/dokumenti/naziv/${naziv}`);
};

const uploadDokument = (formData) => {
    return instance.post("/dokument/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true, 
    });
  };


export const getById = (id) =>
{
    return instance.get(`/dokument/${id}`);
}

export const getDokumentiByKategorijaId = (idKategorije) =>
    {
        return instance.get(`/dokument/kategorija/${idKategorije}`);
    }


export default
{
    getAll,deleteDokument,addDokument, getById, getDokumentiByKategorijaId, uploadDokument
};